<template>
  <div id="login_box">

    <language-select></language-select>

    <img class="logo" src="../assets/images/logo.png" alt="Logo RED" />

    <h2 v-translate>Přihlášení do systému</h2>

    <div class="error" v-if="error">
      <div class="inner_box">
        <p>{{ errorMessage }}</p>
      </div>
    </div>

    <form @submit.prevent="submitLogin">
      <p class="field">
        <label for="login"  v-translate>Přihlašovací jméno</label>
        <input
            id="login"
            v-model="formData.username"
            name="username"
            type="text"
            :disabled="formDisabled"
            v-validate="{ required: true }"
        />
      </p>
      <p class="field">
        <label for="passsword"  v-translate>Heslo</label>
        <input
            id="passsword"
            name="passsword"
            size="30" v-model="formData.password"
            type="password"
            :disabled="formDisabled"
            v-validate="{ required: true }"
        />
      </p>

      <p class="login_buttons">
        <input
            class="btn"
            type="submit"
            :disabled="formDisabled"
            :value="translations.login"
        >
      </p>
    </form>

  <LoginTable v-if="showLoginTable" @selectAccount="selectAccount" />

  </div>
</template>

<script>
import LoginTable from 'components/LoginTable'
import appTitleMixin from '../mixins/appTitleMixin'
import LanguageSelect from '../components/AppContent/LanguageSelect'
import * as DEFAULT_API_PARAMS from 'constants/defaultApiParams'
import { mapActions } from 'vuex'

export default {
  name: 'login',
  mixins: [appTitleMixin(['Login'])],
  components: {
    LoginTable,
    LanguageSelect
  },
  data() {
    return {
      error: false,
      errorMessage: null,
      formDisabled: false,
      showLoginTable: false,
      formData: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    translations() {
      return {
        login: this.$gettext('Přihlásit')
      }
    },
    loginBoxCssClass() {
      return {
        error: this.error
      }
    }
  },
  methods: {
    ...mapActions([
      'resetParamsPaginationAndSearch'
    ]),
    submitLogin(e) {
      this.error = false
      this.formDisabled = true

      this.$auth.login({
        data: this.formData,
        rememberMe: true
      }).then(res => {
        this.$auth.user(res.data.data)
        this.$auth.token(null, res.data.data.token)
        this.$auth.watch.authenticated = true
        this.$auth.watch.loaded = true
      }).then(() => {
        this.resetParamsPaginationAndSearch(DEFAULT_API_PARAMS)
        this.$router.replace({ name: 'epgs' })
      }).catch((err) => {
        if (err.response.status === 401) {
          this.errorMessage = 'Chybně zadané přihlašovací údaje'
        } else if (err.response.status >= 400 && err.response.status < 500) {
          this.errorMessage = 'Došlo k chybě při přihlašování. Pro vyřešení problému prosím kontaktujte správce.'
        } else {
          this.errorMessage = 'Došlo k chybě, zkuste to prosím znovu.'
        }

        this.error = true
        this.formDisabled = false
      })
    },
    selectAccount(account) {
      this.formData.username = account.login
      this.formData.password = account.password
      this.submitLogin()
    }
  }
}
</script>
